import {SignalREvent, SignalRHub} from 'constants/dataEnum';
import {invokeAPI} from 'stores/business/commonBusiness';
import GlobalReduxStore from 'stores/globalReduxStore';

export const checkIsHumidifierInstalled = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_HUMIDIFIER_INSTALLED));
  } catch (error) {
    console.error('error in checkIsHumidifierInstalled', error);
  }

  return response;
};

export const checkIsHumidifierDoorOpened = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_HUMIDIFIER_DOOR_OPENED));
  } catch (error) {
    console.error('error in checkIsHumidifierDoorOpened', error);
  }

  return response;
};

export const checkWaterLevel = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_WATER_LEVEL_LOW));
  } catch (err) {
    console.error('Error in checkWaterLevel:', err);
  }

  return response;
};

export const checkIdleHumidityTarget = async () => {
  const {dispatch} = GlobalReduxStore.getStore();

  try {
    const idleHumidity = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IDLE_HUMIDITY_TARGET));

    return idleHumidity;
  } catch (err) {
    console.error('Error in checkIdleHumidityTarget:', err);

    return null;
  }
};

export const checkIdleHumidityEnabled = async () => {
  const {dispatch} = GlobalReduxStore.getStore();

  try {
    const isEnabled = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_IDLE_HUMIDITY_ENABLE));

    return isEnabled;
  } catch (err) {
    console.error('Error in checkIdleHumidityEnabled:', err);

    return null;
  }
};

export const checkIsHumidifierConnected = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_HUMIDIFIER_CONNECTED));
  } catch (error) {
    console.error('error in checkIsHumidifierConnected', error);
  }

  return response;
};

export const enableWaterPump = async (enable = true) => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.ENABLE_WATER_PUMP, enable));
  } catch (error) {
    console.error('error in enableWaterPump', error);
  }

  return response;
};
